export default __webpack_public_path__ + "static/media/landing_image.7dc231c8.png";